import styled, { createGlobalStyle } from 'styled-components'
import { color } from 'ui/themes/utils'

import P from 'ui/elements/P'
import Hr from 'ui/elements/Hr'

const BaseGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-gap: 8px;

  ${P} {
    margin: 0;
  }
`

export const HostStyles = createGlobalStyle`
  :host {
    --totals-text-color: var(--color-primary-foreground, ${color('Text/Primary')});

    --totals-border: 1px solid var(--color-border, ${color('Misc/Divider')});

    --totals-breakdown-font-size: 16px;
    --totals-breakdown-font-weight: 400;

    --totals-total-font-size: 20px;
    --totals-total-font-weight: 700;

    --totals-error-padding: 16px;
    --totals-error-border-radius: 8px;
    --totals-error-background-color: #FFEAEF;
    --totals-error-color: var(--color-red, ${color('Danger/Base')});
    --totals-error-gap: 16px;
    --totals-error-font-size: 16px;
    --totals-error-font-weight: 400;
  }

  ${Hr} {
    border: none;
    border-top: var(--totals-border);
  }
`

export const Breakdown = styled(BaseGrid)`
  ${P} {
    font-family: var(--font-body);
    font-size: var(--totals-breakdown-font-size);
    font-weight: var(--totals-breakdown-font-weight);

    color: var(--totals-text-color);
  }
`

export const Total = styled(BaseGrid)`
  ${P} {
    font-family: var(--font-body);
    font-size: var(--totals-total-font-size);
    font-weight: var(--totals-total-font-weight);

    color: var(--totals-text-color);
  }
`

export const Error = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  align-items: center;

  padding: var(--totals-error-padding);

  border-radius: var(--totals-error-border-radius);

  background-color: var(--totals-error-background-color);

  gap: var(--totals-error-gap);

  svg {
    width: 20px;
    height: 20px;

    fill: var(--totals-error-color);
    color: var(--totals-error-color);
  }

  ${P} {
    margin: 0;

    font-family: var(--font-body);
    font-size: var(--totals-error-font-size);
    font-weight: var(--totals-error-font-weight);

    color: var(--totals-error-color);
  }
`
